// src/constants/Permissions.ts

export const Permissions = {
    Dashboard: {
        View: 'Permissions.Dashboard.View',
    },
    Users: {
        View: 'Permissions.Users.View',
        Create: 'Permissions.Users.Create',
        Edit: 'Permissions.Users.Edit',
        Delete: 'Permissions.Users.Delete',
    },
    Roles: {
        View: 'Permissions.Roles.View',
        Manage: 'Permissions.Roles.Manage',
    },
    Products: {
        View: 'Permissions.Products.View',
        Create: 'Permissions.Products.Create',
        Edit: 'Permissions.Products.Edit',
        Delete: 'Permissions.Products.Delete',
    },
    Claims: {
        View: 'Permissions.Claims.View',
        Process: 'Permissions.Claims.Process',
        Edit: 'Permissions.Claims.Edit',
    },
    Payments: {
        View: 'Permissions.Payments.View',
        Process: 'Permissions.Payments.Process',
    },
    Customers: {
        View: 'Permissions.Customers.View',
        Manage: 'Permissions.Customers.Manage',
    },
    Support: {
        View: 'Permissions.Support.View',
        Reply: 'Permissions.Support.Reply',
    },
    Configuration: {
        View: 'Permissions.Configuration.View',
        Manage: 'Permissions.Configuration.Manage',
    },
} as const;

export type PermissionKey = string;

export const PermissionLabels: Record<string, string> = {
    [Permissions.Dashboard.View]: 'View Dashboard',
    [Permissions.Users.View]: 'View Users',
    [Permissions.Users.Create]: 'Create Users',
    [Permissions.Users.Edit]: 'Edit Users',
    [Permissions.Users.Delete]: 'Delete Users',
    [Permissions.Roles.View]: 'View Roles',
    [Permissions.Roles.Manage]: 'Manage Roles & Permissions',
    [Permissions.Products.View]: 'View Products',
    [Permissions.Products.Create]: 'Create Products',
    [Permissions.Products.Edit]: 'Edit Products',
    [Permissions.Products.Delete]: 'Delete Products',
    [Permissions.Claims.View]: 'View Claims',
    [Permissions.Claims.Process]: 'Process Claims',
    [Permissions.Claims.Edit]: 'Edit Claims',
    [Permissions.Payments.View]: 'View Payments',
    [Permissions.Payments.Process]: 'Process Payments',
    [Permissions.Customers.View]: 'View Customers',
    [Permissions.Customers.Manage]: 'Manage Customers',
    [Permissions.Support.View]: 'View Support Tickets',
    [Permissions.Support.Reply]: 'Reply to Support Tickets',
    [Permissions.Configuration.View]: 'View System Configuration',
    [Permissions.Configuration.Manage]: 'Manage System Configuration',
};

export const PermissionGroups = [
    { name: 'Dashboard', permissions: [Permissions.Dashboard.View] },
    { name: 'User Management', permissions: [Permissions.Users.View, Permissions.Users.Create, Permissions.Users.Edit, Permissions.Users.Delete] },
    { name: 'Role Management', permissions: [Permissions.Roles.View, Permissions.Roles.Manage] },
    { name: 'Product Management', permissions: [Permissions.Products.View, Permissions.Products.Create, Permissions.Products.Edit, Permissions.Products.Delete] },
    { name: 'Claims Management', permissions: [Permissions.Claims.View, Permissions.Claims.Process, Permissions.Claims.Edit] },
    { name: 'Payments', permissions: [Permissions.Payments.View, Permissions.Payments.Process] },
    { name: 'Customer Management', permissions: [Permissions.Customers.View, Permissions.Customers.Manage] },
    { name: 'Support', permissions: [Permissions.Support.View, Permissions.Support.Reply] },
    { name: 'Configuration', permissions: [Permissions.Configuration.View, Permissions.Configuration.Manage] },
];
